import { Component } from "@angular/core";

@Component({
    selector: "app",
    template: "<router-outlet></router-outlet>"
})
export class AppComponent { }



// WEBPACK FOOTER //
// C:/Users/BiggaHD/Desktop/projects/sportStore/src/app/app.component.ts